import { render, staticRenderFns } from "./BreakingChangeConfirm.vue?vue&type=template&id=1793449c&scoped=true"
import script from "./BreakingChangeConfirm.vue?vue&type=script&lang=ts"
export * from "./BreakingChangeConfirm.vue?vue&type=script&lang=ts"
import style0 from "./BreakingChangeConfirm.vue?vue&type=style&index=0&id=1793449c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1793449c",
  null
  
)

export default component.exports